<template>
  <transition name="modal" appear>
    <div class="popWrap nowOpen" id="couponPop">
      <span class="blind focusSet first" tabindex="0"></span>
      <div class="popup">
        <div class="popContain">
          <div class="popCont hasBtn" tabindex="-1" role="dialog">
            <div class="popBody">
              <div class="popInner">
                <!-- 본문 (s) -->
                <section>
                  <div class="titArea ac">
                    <h1 class="titH1 medium">이 상품에 적용 가능한 쿠폰</h1>
                  </div>

                  <ul class="couponList">
                    <li v-for="(coupon, couponIndex) in couponList" :key="couponIndex">
                      <a class="block bgColor0" @click="selectCoupon(coupon)">
                        <div class="inner">
                          <span class="copy" v-text="coupon.title"></span>
                          <strong class="copy">{{ coupon.discountAmount | currency }}원 할인</strong>
                          <span class="desc" v-text="setDate(coupon.startDate, coupon.endDate)"></span>
                        </div>
                      </a>
                    </li>
                  </ul>
                </section>
                <!-- 본문 (e) -->
              </div>
            </div>

            <div class="btnArea sticky two half">
              <button type="button" class="btn_g" @click="$emit('close')">닫기</button>
              <button type="button" class="btn_p" @click="allCoupon">모두 받기</button>
            </div>

            <!-- <button type="button" class="btnIco_close" onclick="lp.close();"><span>팝업 닫기</span></button> -->
          </div>
        </div>
      </div>
    </div>
    <!-- popup (e) -->
  </transition>
</template>
<script>
import ApiService from '@/common/api.service';
import $ from 'jquery';

export default {
  name: 'CouponPop',
  props: ['propsProductCode', 'propsCouponType', 'propsIndex'],
  data: function() {
    return {
      productCode: this.propsProductCode,
      couponType: this.propsCouponType,
      index: this.propsIndex,

      couponList: [],
      couponListLength: null,
    };
  },
  mounted() {
    $('body').addClass('popOn');
    let maxH = $(window).height() - 60;
    $('.popWrap')
      .find('.popBody')
      .css('max-height', maxH);
    //ApiService.service('GET', '/product/coupon/' + this.propsProductCode)
    ApiService.service('GET', '/product/' + this.productCode + '/coupon/type/' + this.couponType + '/downloadable')
      .then(({ data }) => {
        console.log(data);
        if (data.isSucceed) {
          this.couponList = data.result;
          this.couponListLength = data.result.length;
        }
      })
      .catch(({ response }) => {
        console.log('error : ' + response);
      });
  },
  beforeDestroy() {
    $('body').removeClass('popOn');
  },
  methods: {
    selectCoupon(coupon) {
      this.$emit('selectCoupon', coupon, this.index);
    },
    allCoupon() {
      let couponIdList = [];
      for (let coupon of this.couponList) {
        couponIdList.push(coupon);
      }
      console.log('couponIdList');
      console.log(couponIdList);
      this.$emit('allCoupon', couponIdList, this.index);
    },
    setDate(startDate, endDate) {
      let startDateYear = startDate.substring(0, 4);
      let startDateMonth = startDate.substring(4, 6);
      let startDateDay = startDate.substring(6, 8);

      let endDateYear = endDate.substring(0, 4);
      let endDateMonth = endDate.substring(4, 6);
      let endDateDay = endDate.substring(6, 8);

      let startDateObj = new Date(startDateYear, Number(startDateMonth) - 1, startDateDay);
      let endDateObj = new Date(endDateYear, Number(endDateMonth) - 1, endDateDay);

      let diffDay = (endDateObj.getTime() - startDateObj.getTime()) / (1000 * 60 * 60 * 24);

      return (
        startDateYear +
        '-' +
        startDateMonth +
        '-' +
        startDateDay +
        '~' +
        endDateYear +
        '-' +
        endDateMonth +
        '-' +
        endDateDay +
        '(' +
        diffDay +
        '일 남음)'
      );
    },
  },
};
</script>

<style lang="stylus" scoped>
@import './css/popup.styl';
</style>
